export default "__VITE_ASSET__3e4987fe__"